import {
  CANADA_BRANCH,
  CANADA_CONTRACT,
  DELIVERY_NOTE_PDF_NAME_MODES,
} from "constants/constants";

const formatLabels = (inputs) =>
  inputs.reduce(
    (prev, curr) => ({
      ...prev,
      [curr]: {
        id: `input_${curr}_label`,
        defaultMessage: `${curr} *`,
      },
    }),
    {}
  );
const formatPlaceholders = (inputs) =>
  inputs.reduce(
    (prev, curr) => ({
      ...prev,
      [curr]: {
        id: `input_${curr}_placeholder`,
        defaultMessage: `${curr} *`,
      },
    }),
    {}
  );

// Every category field carries the same label, whichever form declares it.
// Filter screens that own no form constants read it straight from here.
export const JOB_CATEGORY_LABEL = {
  id: "input_domain_category_id_label",
  defaultMessage: "Catégorie de métier",
};

// Shown for a category the select no longer offers (AUTRES).
export const JOB_CATEGORY_NONE = {
  id: "input_domain_category_none",
  defaultMessage: "-",
};

// Placeholder of a job field held inert until a category is picked (redmine
// 12939). Shared: the gate is the same rule on every screen that carries both
// fields, so the wording has to be too.
export const JOB_LOCKED_PLACEHOLDER = {
  id: "input_domain_id_pick_category_first",
  defaultMessage: "Choisissez d'abord une catégorie",
};

// Empty job field whose category IS picked: a category change can invalidate a
// row's job and blank the cell, and a blank cell gives no clue that the line
// now needs one — the save then fails on a generic error naming no row.
export const JOB_EMPTY_PLACEHOLDER = {
  id: "input_domain_id_pick_job",
  defaultMessage: "Choisissez un métier",
};

export const STAFF_FORM_INPUTS = [
  "avatar_id",
  "address",
  "birth_place",
  "birthday",
  "branch_id",
  "cegid_id",
  "children_information",
  "coefficient_id",
  "contract_type",
  "contractual_status_id",
  "dav_function",
  "degree",
  "degree_year",
  "email",
  "end_date",
  "first_name",
  "gender",
  "gp_id",
  "last_name",
  "leaving_reason_id",
  "manager_id",
  "nationality",
  "nationality_id",
  "personal_email",
  "phone_number",
  "picture_file_id",
  // "position_id",
  "recruitment_mode_id",
  "referer_external",
  "referer_internal_id",
  "role",
  "assigned_branches",
  "start_date",
  // "syntec_coefficient_id",
  "syntec_coef_position_staff",
  "visa",
  "visa_expiration_date",
  "visa_number",
  "visa_status",
  "visa_type",
  // "years_experience",
  "years_experience_mobile",
  "arrival_date",
  "profile_id",
  "school",
  "school_level",
  "subsidiary",
];
export const CONSULTANT_FORM_INPUTS = [
  "avatar_id",
  "address",
  "birth_place",
  "birthday",
  "branch_id",
  "subsidiary",
  "children_information",
  "coefficient_id",
  "comment",
  "contract_type",
  "contractual_status_id",
  "currency_id",
  "domain_id",
  "degree",
  "degree_year",
  "dyb_showcase_id",
  "first_name",
  "gender",
  "gp_id",
  "last_name",
  "manager_id",
  "nationality",
  "nationality_id",
  "personal_email",
  "phone_number",
  "picture_file_id",
  "leaving_reason_id",
  "position_id",
  "recruitment_mode_id",
  "referer_external",
  "referer_internal_id",
  "role",
  "salary",
  // "syntec_coefficient_id",
  "syntec_coef_position",
  "visa",
  "visa_expiration_date",
  "visa_number",
  "visa_status",
  "visa_type",
  "years_experience",
  "years_experience_mobile",
  "start_date",
  "cegid_id",
  "dashboard_commentary",
  "arrival_date",
  "arrival_date_at_Davidson",
  "email",
  "school",
  "school_level",
  "recruitment_experience",
  "end_date",
];
export const CLIENT_FORM_INPUTS = [
  "email",
  "username",
  "role",
  "name",
  "address",
  "postal_code",
  "city",
  "country",
  "sector",
  "is_visible",
  "billing_client_id",
  "picture_file_id",
  "managers",
  "affiliate_id",
  "assigned_managers",
  "strategic",
];

export const CONSULTANT_GENERAL_INFO_DEFAULT_VALUES = {
  dyb_name: "",
  start_date: "",
  degree: "",
  degree_year: "",
  years_experience: "",
  skills: [],
  mobility: [],
  branch_id: [],
  dashboard_commentary: "",
  comment: "",
  comments: [],
  recruitment_experience: null,
  picture_file_id: "",
};

export const SC_FORM_INPUTS = [
  "first_name",
  "last_name",
  "cdi_start_date",
  "function",
  "years_of_experience",
  "interview_date",
  "manager_id",
  "diploma",
  "last_interview_date",
  "salary_evolution",
  "professional_evolution",
];

export const SUBCONTRACTOR_FORM_INPUTS = [
  "first_name",
  "last_name",
  "personal_email",
  "phone_number",
  "picture_file_id",
  "gender",
  "remuneration", //remuneration_type
  "payment_deadline",
  "currency_id",
  "remuneration_tarification",
  "remuneration_other",
  "branch",
  "manager_id",
  "comment",
  "company_comment",
  "contract_start_date",
  "company_name",
  "siren",
];

export const BILLING_COMPANY_FORM_INPUTS = [
  "nationality_id",
  "payment_condition_id",
  "tax_regime_id",
  "tva_regime_id",
  "name",
  "slug",
  "siren",
  "siret",
  "billing_address",
  "billing_postal_code",
  "billing_city",
  "billing_country",
  "accounting_contact_first_name",
  "accounting_contact_last_name",
  "accounting_contact_email",
  "intercommunity_tva_number",
  "auxiliary_code",
  "qweeby_chorus_code",
  "qweeby_received",
  "qweeby_demat_flag",
];

export const MISSION_FORM_INPUTS = [
  "client_contact_linkedin",
  "worker_id",
  "mission_manager_id", //manager_id
  "adv_id",
  "signed_by_id",
  "charged_by_id",
  "type_",
  "client_id",
  "mission_name", //name
  "status",
  "mission_type", //type_
  "final_client",
  "affectation_number",
  "intervention_address",
  "purchasing_contact",
  "mission_start_date", //start_date
  "scheduled_end_date",
  "mission_end_date", //end_date
  "billing_type",
  "billing_daily_fee_comment",
  "transport_fee",
  "mission_fee",
  "transport_fee_comment",
  "restoration_fee",
  "restoration_fee_comment",
  "other_fee_comment",
  "billing_condition",
  "sale_toil_authorized",
  "general_comment",
  "computer",
  "client_contact",
  "client_contact_email",
  "client_contact_phonenumber",
  "rate_coordinator",
  "description",
  "mission_order_file_name",
  "mission_order_file_path",
  "contract_sharepoint_url",
  "mission_order_submission_date",
  "closed_at",
  "deleted",
  "import_option",
  "is_confidential",
  "telephone",
  "currency_id",
  "is_star",
  "cslt_job_mission", //domain_id
  "appeal_id",
  "TAD",
  "remote_work_days",
  "non_remote_days_number",
  "remote_days_answer_tag",
  "impact",
];

export const OBJECTIVES_MODAL_FORM_INPUTS = [
  "date",
  "updated_by",
  "type",
  "concerned_user",
  "year",
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const OBJECTIVES_MODAL_FORM_DEFAULT_VALUES = {
  date: "",
  updated_at: "",
  updated_by: null,
  type: null,
  concerned_user: null,
  year: 0,
  january: 0,
  february: 0,
  march: 0,
  april: 0,
  may: 0,
  june: 0,
  july: 0,
  august: 0,
  september: 0,
  october: 0,
  november: 0,
  december: 0,
};

export const BILLING_COMPANY_FORM_DEFAULT_VALUES = {
  nationality_id: "",
  payment_condition_id: "V01",
  tax_regime_id: null,
  tva_regime_id: "",
  name: "",
  slug: "",
  siren: "",
  siret: "",
  billing_address: "",
  billing_postal_code: "",
  billing_city: "",
  billing_country: "",
  accounting_contact_first_name: null,
  accounting_contact_last_name: null,
  accounting_contact_email: null,
  intercommunity_tva_number: "",
  auxiliary_code: "",
  qweeby_chorus_code: null,
  qweeby_received: false,
  qweeby_demat_flag: "",
};

export const SUBCONTRACTOR_FORM_DEFAULT_VALUES = {
  first_name: "",
  last_name: "",
  phone_number: "",
  email: "",
  gender: "",
  picture_file_id: "",
  remuneration_type: "tarification",
  payment_deadline: "",
  currency_id: "",
  remuneration_tarification: "",
  remuneration_other: "",
  remuneration_comment: null,
  branch_id: "",
  manager_id: "",
  comment: "",
  company_comment: null,
  contract_start_date: "-",
  str_company_name: "",
  siren: "",
};

export const CONSULTANT_FORM_DEFAULT_VALUES = {
  address: "",
  arrival_date: null,
  birth_place: "",
  birthday: "",
  branch_id: "",
  children_information: 0,
  coefficient_id: "",
  comment: "",
  contract_type: "",
  contractual_status_id: null,
  currency_id: "",
  domain_category_id: "",
  domain_id: "",
  degree: "",
  degree_year: "",
  dyb_showcase_id: "",
  first_name: "",
  gender: "",
  gp_id: "",
  last_name: "",
  manager_id: "",
  nationality: "",
  personal_email: "",
  leaving_reason_id: null,
  phone_number: "",
  picture_file_id: "",
  position_id: "",
  recruitment_mode_id: "",
  referer_external: "",
  referer_internal_id: "",
  role: "",
  salary: "",
  syntec_coef_position: [],
  visa: false,
  visa_expiration_date: null,
  visa_number: null,
  visa_status: "",
  visa_type: null,
  years_experience: "",
  experience_comment: null,
  cegid_id: "",
  school: "",
  school_level: "",
  recruitment_experience: null,
  end_date: null,
};
export const PROSPECTION_FORM_DEFAULT_VALUES = {
  sector: "",
  name: "",
  nature: "",
  default_color: null,
};
export const STAFF_FORM_DEFAULT_VALUES = {
  address: "",
  birth_place: "",
  birthday: "",
  branch_id: "",
  children_information: 0,
  coefficient_id: "",
  comment: "",
  contract_type: "",
  contractual_status_id: null,
  dav_function: "",
  degree: "",
  degree_year: "",
  end_date: null,
  first_name: "",
  gender: "",
  gp_id: "",
  last_name: "",
  leaving_reason_id: "",
  manager_id: "",
  nationality: [],
  personal_email: "",
  phone_number: "",
  picture_file_id: "",
  position_id: "",
  recruitment_mode_id: "",
  referer_external: "",
  referer_internal_id: "",
  role: [],
  start_date: "",
  syntec_coef_position_staff: [],
  visa: false,
  visa_expiration_date: null,
  visa_number: null,
  visa_status: "",
  visa_type: null,
  years_experience: null,
  arrival_date: "",
  profile_id: "",
  school: "",
  school_level: "",
  assigned_branches: [],
};

export const CLIENT_FORM_DEFAULT_VALUES = {
  email: "",
  username: "",
  role: "",
  enabled: false,
  affiliate_id: [],
  name: "",
  address: "",
  postal_code: "",
  city: "",
  country: "",
  sector_id: "",
  is_visible: true,
  billing_client_id: null,
  picture_file_id: "",
  assigned_managers: [],
  strategic: false,
};

export const OBJECTIVES_AND_REALIZED_FORM_DEFAULT_VALUES = {
  subsidiary: [],
  manager: [],
};
export const OBJECTIVES_AND_REALIZED_FORM_INPUTS = ["subsidiary", "manager"];
export const OBJECTIVES_AND_REALIZED_FORM_LABELS = formatLabels(
  OBJECTIVES_AND_REALIZED_FORM_INPUTS
);
export const OBJECTIVES_AND_REALIZED_FORM_PLACEHOLDERS = formatPlaceholders(
  OBJECTIVES_AND_REALIZED_FORM_INPUTS
);

export const ABAQUE_FORM_DEFAULT_VALUES = {
  domain_category_id: [],
  domain_id: [],
  branch_id: [],
  experience: null,
};
export const ABAQUE_FORM_INPUTS = ["domain_id", "branch_id", "experience"];
export const ABAQUE_FORM_LABELS = formatLabels(ABAQUE_FORM_INPUTS);

export const SUBCONTRACTING_COMPANY_DEFAULT_VALUES = {
  company_name: "",
  siren: null,
  siret: null,
  auxiliary_code: "",
  postal_code: "",
  city: "",
  country: "",
  address: "",
  accounting_contact_first_name: null,
  accounting_contact_last_name: null,
  accounting_contact_email: null,
  nationality_id: [],
  partner_connection: false,
  company_name_short: "",
  partner_email: "",
};

export const SHARED_DASHBOARD_FORM_DEFAULT_VALUES = {
  subsidiary_intercontracts: [],
  subsidiary_missions_exit_activation: [],
  subsidiary_ed: [],
  subsidiary_ok: [],
  subsidiary_long_leave: [],
  subsidiary_companies_exits: [],
  manager_intercontracts: [],
  manager_missions_exit_activation: [],
  manager_missions_ed: [],
  manager_ok: [],
  manager_long_leave: [],
  manager_companies_exits: [],
  start_date: "",
  date: "",
  dav_function_intercontracts: [],
  dav_function_missions_exit_activation: [],
  dav_function_ed: [],
  start_at: [],
  exits_companies_by: "all",
  after_date_of: "",
  mobility: "",
};
export const SHARED_DASHBOARD_FORM_INPUTS = [
  "subsidiary",
  "manager_name",
  "ic_start",
  "date",
  "dav_function",
  "start_at",
  "exits_companies_by",
  "after_date_of",
  "mobility",
];
export const SHARED_DASHBOARD_FORM_LABELS = formatLabels(
  SHARED_DASHBOARD_FORM_INPUTS
);
export const SHARED_DASHBOARD_PLACEHOLDERS = formatPlaceholders(
  SHARED_DASHBOARD_FORM_INPUTS
);

export const DEFINITIVE_BACKUP_DEFAULT_VALUES = {
  worker_id: [],
  arrival_date_replacement: "",
  replacement_start_date: "",
};

export const DEFINITIVE_BACKUP_INPUTS = [
  "worker_id",
  "arrival_date_replacement",
  "replacement_start_date",
];

export const DEFINITIVE_BACKUP_LABELS = formatLabels(DEFINITIVE_BACKUP_INPUTS);
export const DEFINITIVE_BACKUP_PLACEHOLDERS = formatPlaceholders(
  DEFINITIVE_BACKUP_INPUTS
);

export const TEMPORARY_BACKUP_DEFAULT_VALUES = {
  worker_id: [],
  arrival_date_replacement: "",
  replacement_start_date: "",
  replacement_end_date: "",
  departure_date_of_replacement: "",
};

export const TEMPORARY_BACKUP_INPUTS = [
  "worker_id",
  "arrival_date_replacement",
  "replacement_start_date",
  "replacement_end_date",
  "departure_date_of_replacement",
];

export const TEMPORARY_BACKUP_LABELS = formatLabels(TEMPORARY_BACKUP_INPUTS);
export const TEMPORARY_BACKUP_PLACEHOLDERS = formatPlaceholders(
  TEMPORARY_BACKUP_INPUTS
);

export const MISSION_DEFAULT_VALUES = {
  client_contact_linkedin: "",
  address: "",
  adv_id: [],
  affectation_number: "",
  appeal_id: null,
  billing_condition: null,
  mission_fee: "",
  billing_daily_fee_comment: null,
  billing_type: "daily",
  charged_by_id: [],
  client_contact: "",
  client_contact_email: "",
  client_contact_phonenumber: "",
  client_id: [],
  closed_at: "",
  computer: null,
  currency_id: null,
  deleted: false,
  description: null,
  domain_category_id: "",
  domain_id: [],
  end_date: null,
  final_client: null,
  general_comment: null,
  impact: null,
  import_option: "importable",
  is_visible: null,
  is_star: null,
  manager_id: [],
  mission_order_file_name: null,
  mission_order_file_path: "",
  mission_order_submission_date: null,
  name: "",
  non_remote_days_number: null,
  other_fee_comment: null,
  purchasing_contact: "",
  rate_coordinator: [],
  remote_days_answer_tag: null,
  remote_work_days: null,
  remote_work_id: null,
  restoration_fee: null,
  restoration_fee_comment: null,
  sale_toil_authorized: false,
  scheduled_end_date: null,
  signed_by_id: [],
  start_date: "",
  telephone: null,
  transport_fee: null,
  transport_fee_comment: null,
  type_: "",
  worker_id: [],
};

export const SUBCONTRACTING_COMPANY_INPUTS = [
  "company_name",
  "siren",
  "siret",
  "auxiliary_code",
  "postal_code",
  "city",
  "country",
  "address",
  "first_name",
  "last_name",
  "accounting_contact_email",
  "nationality",
  "partner_connection",
  "partner_email",
];

export const STAFF_FORM_DEFAULT_EDITION_EXTRA_VALUES = {
  cegid_id: "",
  email: "",
  enabled: "",
};

export const PAYMENT_DEADLINE_OPTIONS = [
  { value: "15", label: "15", id: "15" },
  { value: "30", label: "30", id: "30" },
  { value: "45", label: "45", id: "45" },
  { value: "60", label: "60", id: "60" },
];

export const AFFECT_MANAGER_LABEL = {
  id: "affect_manager",
  defaultMessage: "Affectation manager *",
};

export const ASSIGNMENT_RESPONSE_COMMENT = {
  id: "assignment_response_comment",
  defaultMessage:
    "Pour quelle(s) raison(s) souhaitez-vous refuser cette demande d'assignation ?",
};

export const MISSION_FORM_LABELS = formatLabels(MISSION_FORM_INPUTS);
export const MISSION_FORM_PLACEHOLDERS =
  formatPlaceholders(MISSION_FORM_INPUTS);

export const BILLING_CLIENT_FORM_LABELS = formatLabels(
  BILLING_COMPANY_FORM_INPUTS
);
export const BILLING_COMPANY_FORM_PLACEHOLDERS = formatPlaceholders(
  BILLING_COMPANY_FORM_INPUTS
);
export const SUBCONTRACTOR_FORM_LABELS = formatLabels(
  SUBCONTRACTOR_FORM_INPUTS
);
export const SUBCONTRACTOR_FORM_PLACEHOLDERS = formatPlaceholders(
  SUBCONTRACTOR_FORM_INPUTS
);

export const SUBCONTRACTING_COMPANY_FORM_LABELS = formatLabels(
  SUBCONTRACTING_COMPANY_INPUTS
);
export const SUBCONTRACTING_COMPANY_FORM_PLACEHOLDERS = formatPlaceholders(
  SUBCONTRACTING_COMPANY_INPUTS
);

export const SC_FORM_LABELS = formatLabels(SC_FORM_INPUTS);
export const SC_FORM_PLACEHOLDERS = formatPlaceholders(SC_FORM_INPUTS);
export const STAFF_FORM_LABELS = formatLabels(STAFF_FORM_INPUTS);
export const STAFF_FORM_PLACEHOLDERS = formatPlaceholders(STAFF_FORM_INPUTS);
export const CONSULTANT_FORM_LABELS = formatLabels(CONSULTANT_FORM_INPUTS);
export const CONSULTANT_FORM_PLACEHOLDERS = formatPlaceholders(
  CONSULTANT_FORM_INPUTS
);
export const CLIENT_FORM_LABELS = formatLabels(CLIENT_FORM_INPUTS);
export const CLIENT_FORM_PLACEHOLDERS = formatPlaceholders(CLIENT_FORM_INPUTS);

export const REMOTE_DAYS_NUMBER = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
];

export const GENDER_OPTIONS = [
  {
    value: "m",
    label: {
      id: "input_gender_option_one",
      defaultMessage: "M.",
    },
  },
  {
    value: "mrs",
    label: {
      id: "input_gender_option_two",
      defaultMessage: "Mme.",
    },
  },
];

export const VISA_TYPES = [
  {
    value: "employee",
    label: { id: "visa_type_employee", defaultMessage: "Salarié" },
  },
  {
    value: "student",
    label: { id: "visa_type_student", defaultMessage: "Etudiant" },
  },
  {
    value: "aps_rece",
    label: { id: "aps_rece", defaultMessage: "APS ou RECE" },
  },
  {
    value: "pt_eu_blue_card",
    label: {
      id: "pt_eu_blue_card",
      defaultMessage: "PT Carte Bleue Européenne",
    },
  },
  {
    value: "pt_family",
    label: {
      id: "talent_passeport_family",
      defaultMessage: "PT famille",
    },
  },
  {
    value: "pt_employee",
    label: {
      id: "pt_employee",
      defaultMessage: "PT Salarié qualifié",
    },
  },
  {
    value: "other",
    label: { id: "visa_type_other", defaultMessage: "Autre" },
  },
];

export const VISA_STATUS = [
  {
    value: "in_progress",
    label: { id: "visa_status_in_progress", defaultMessage: "En cours" },
  },
  {
    value: "ok",
    label: { id: "visa_status_ok", defaultMessage: "OK" },
  },
  {
    value: "refused",
    label: { id: "visa_status_refused", defaultMessage: "Refusé" },
  },
  {
    value: "stopped",
    label: { id: "visa_status_stopped", defaultMessage: "Stoppé" },
  },
];

export const REMUNERATION_OPTIONS = [
  {
    value: "tarification",
    label: {
      id: "pricing",
      defaultMessage: "Journalier",
    },
  },
  {
    value: "other",
    label: { id: "other", defaultMessage: "Autre" },
  },
];

export const CONTRACT_TYPE_OPTIONS = [
  {
    value: "cdi",
    label: { id: "cdi", defaultMessage: "CDI" },
  },
  {
    value: "cdd",
    label: { id: "cdd", defaultMessage: "CDD" },
  },
  {
    value: "internship",
    label: { id: "training", defaultMessage: "Stage" },
  },
  {
    value: "professionalization",
    label: {
      id: "professional_contract",
      defaultMessage: "Contrat de professionnalisation",
    },
  },
  {
    // HF-0253 : la valeur doit matcher l'enum backend ContractType::Learning
    // ("learning") ; "apprenticeship" ne correspondait à rien → champ vide.
    value: "learning",
    label: {
      id: "apprenticeship_contract",
      defaultMessage: "Contrat d'apprentissage",
    },
  },
  {
    value: "temporary",
    label: { id: "interim", defaultMessage: "Intérim" },
  },
  {
    value: "representative",
    label: {
      id: "representative",
      defaultMessage: "Mandataire",
    },
  },
  {
    value: "vie",
    label: { id: "vie", defaultMessage: "VIE" },
  },
  {
    value: "canada_temporary_contract",
    label: {
      id: "canada_temporary_contract",
      defaultMessage: "Contrat temporaire (Canada only)",
    },
  },
];

// HF-0256 : options de type de contrat selon la branche. Sur une branche non-Canada,
// le contrat Canada n'est pas proposé — sauf s'il est déjà la valeur courante, afin que
// les contrats existants restent affichés (InputSelect rend vide si la valeur est absente
// des options).
export const getContractTypeOptions = (branchLabel, currentValue) =>
  branchLabel === CANADA_BRANCH
    ? CONTRACT_TYPE_OPTIONS
    : CONTRACT_TYPE_OPTIONS.filter(
        (e) => e.value !== CANADA_CONTRACT || e.value === currentValue
      );

export const SCHOOL_LEVEL_OPTIONS = [
  {
    value: "level_eight",
    label: { id: "school_level_8", defaultMessage: "Doctorat - Niveau 8" },
  },
  {
    value: "level_seven",
    label: {
      id: "school_level_7",
      defaultMessage: "Master, Diplôme d'ingénieur - Niveau 7",
    },
  },
  {
    value: "level_six",
    label: {
      id: "school_level_6",
      defaultMessage: "Licence, Maîtrise - Niveau 6",
    },
  },
  {
    value: "level_five",
    label: { id: "school_level_5", defaultMessage: "BTS, DUT - Niveau 5" },
  },
  {
    value: "level_four",
    label: { id: "school_level_4", defaultMessage: "Baccalauréat - Niveau 4" },
  },
  {
    value: "level_three",
    label: { id: "school_level_3", defaultMessage: "CAP, BEP - Niveau 3" },
  },
  {
    value: "out_system",
    label: { id: "out_of_nomenclature", defaultMessage: "Hors nomenclature" },
  },
];

export const CONTRACTUAL_STATUS_OPTIONS = [
  {
    label: { id: "executive_label", defaultMessage: "Cadre" },
    value: "executive",
  },
  {
    label: { id: "not_executive_label", defaultMessage: "Non cadre" },
    value: "not_executive",
  },
  {
    label: { id: "trainee", defaultMessage: "Stagiaire" },
    value: "internship",
  },
];
export const CONTRACTUAL_STATUS = {
  EXECUTIVE: "executive",
  NOT_EXECUTIVE: "not_executive",
  INTERNSHIP: "internship",
};

export const formatRoles = (roles) =>
  roles.map((role) => ({
    value: role,
    label: role,
    type: "roles",
  }));

export const ROLE_CSE = "ROLE_CSE";
export const ROLE_PLPM = "ROLE_PLPM";

export const BILLING_TYPE = [
  {
    value: "daily",
    label: {
      id: "pricing",
      defaultMessage: "Journalière",
    },
  },
  {
    value: "other",
    label: { id: "other", defaultMessage: "Autre" },
  },
];

export const MISSION_COMPUTER_INFOS = {
  title: {
    id: "computer",
    defaultMessage: "PC fourni",
  },
  title_right: {
    id: "computer",
    defaultMessage: "PC fourni",
  },
  title_left: {
    id: "computer_false",
    defaultMessage: "PC non fourni",
  },
  content: {
    id: "computer_davidson",
    defaultMessage: "PC fourni par Davidson",
  },
};

export const MISSION_PHONE_INFOS = {
  title: {
    id: "phone",
    defaultMessage: "Téléphone fourni",
  },
  title_right: {
    id: "phone",
    defaultMessage: "Téléphone fourni",
  },
  title_left: {
    id: "phone_false",
    defaultMessage: "Téléphone non fourni",
  },
  content: {
    id: "phone_davidson",
    defaultMessage: "Téléphone fourni par Davidson",
  },
};

export const MISSION_STAR_INFOS = {
  title: {
    id: "is_star",
    defaultMessage: "Mission Star",
  },
  title_right: {
    id: "is_star",
    defaultMessage: "Mission Star",
  },
  title_left: {
    id: "is_star_false",
    defaultMessage: "Mission classique",
  },
  content: {
    id: "is_star_davidson",
    defaultMessage:
      "Mission Star (innovante, stratégique, en rupture) à mettre en avant",
  },
};

export const MISSION_VISIBILITY_INFOS = {
  title: {
    id: "is_visible",
    defaultMessage: "Mission visible",
  },
  title_right: {
    id: "is_visible",
    defaultMessage: "Mission visible",
  },
  title_left: {
    id: "is_visible_false",
    defaultMessage: "Sous NDA",
  },
  content: {
    id: "is_visible_davidson",
    defaultMessage:
      "Mission visible (OUI), sous NDA ou confidentiel défense (NON, n'apparaîtra pas dans résultats de recherche)",
  },
};

export const MISSION_IMPACT_INFOS = {
  title: {
    id: "ODDs",
    defaultMessage: "Impact ODDS",
  },
  title_right: {
    id: "ODDs",
    defaultMessage: "Impact ODDS",
  },
  title_left: {
    id: "ODDs_false",
    defaultMessage: "Pas d'impact",
  },
  content: {
    id: "ODDs_davidson",
    defaultMessage:
      "Ce projet a-t-il un impact positif en rapport avec un des ODD: Energie propre, Alimentation, Pauvreté, Santé, Education, Eau, Biodiversité, Accès à l'emploi, Inclusion, etc ...",
  },
};

export const FORM_INFO = {
  mission_start_date: {
    id: "input-date-mission_start_date",
  },
  mission_end_date: {
    id: "input-date-mission_end_date",
  },
  mission_scheduled_end_date: {
    id: "input-date-misison_scheduled_end_date",
  },
  arrival_date: {
    id: "input-date-arrival_date",
  },
  nationality: {
    popup: {
      title: {
        id: "input_nationality_popup_title",
        defaultMessage: "Recherche et sélectionne une nationalité",
      },
    },
    limitChoice: 1,
  },
  country: {
    popup: {
      title: {
        id: "input_country_popup_title",
        defaultMessage: "Recherche et sélectionne un pays",
      },
    },
    limitChoice: 1,
  },
  birthday: {
    id: "input-date-birthday",
  },
  years_experience: {
    comment_settings: {
      title: {
        id: "input_years_experience_commentary_title",
        defaultMessage: "Laisser un commentaire lié à l'embauche",
      },
      placeholder: {
        id: "input_years_experience_commentary_placeholder",
        defaultMessage: "Ajouter un commentaire",
      },
      button_value: {
        id: "send",
        defaultMessage: "Envoyer",
      },
    },
  },
  comment_internal_training: {
    comment_settings: {
      type: "internal_training",
      title: {
        id: "internal_training_comments",
        defaultMessage: "Commentaires formations internes",
      },
      placeholder: {
        id: "add_comment",
        defaultMessage: "Ajouter un commentaire",
      },
      button_value: {
        id: "send",
        defaultMessage: "Envoyer",
      },
    },
  },
  comment_dashboard: {
    comment_settings: {
      type: "dashboard",
      title: {
        id: "dashboard_comments",
        defaultMessage: "Commentaires Dashboard",
      },
      placeholder: {
        id: "add_comment",
        defaultMessage: "Ajouter un commentaire",
      },
      button_value: {
        id: "send",
        defaultMessage: "Envoyer",
      },
    },
  },
  salary: {
    comment_salary: {
      title: {
        id: "input_comment_salary",
        defaultMessage: "Autres éléments de salaire",
      },
      placeholder: {
        id: "input_comment_salary_placeholder",
        defaultMessage: "Ajouter un commentaire",
      },
      button_value: {
        id: "send",
        defaultMessage: "Envoyer",
      },
    },
  },
  recruitment_mode: {
    popup: {
      title: {
        id: "input_recruitment_mode_popup_title",
        defaultMessage: "Recherche et sélectionne un mode de recrutement",
      },
    },
    limitChoice: 1,
  },

  coopted_by: {
    popup: {
      title: {
        id: "input_coopted_by_popup_title",
        defaultMessage: "Recherche et sélectionne un membre",
      },
    },
    limitChoice: 1,
  },
  visa: {
    id: "visa_id",
  },
  email: {
    disabled: true,
  },

  branch: {
    popup: {
      title: {
        id: "input_branch_popup_title",
        defaultMessage: "Recherche et sélectionne une filiale",
      },
    },
    limitChoice: 1,
  },

  dav_function: {
    popup: {
      title: {
        id: "input_job_popup_title",
        defaultMessage: "Recherche et sélectionne un métier",
      },
    },
    limitChoice: 1,
  },

  dav_function_category: {
    popup: {
      title: {
        id: "input_job_category_popup_title",
        defaultMessage: "Recherche et sélectionne une catégorie",
      },
    },
    limitChoice: 1,
  },
  profile: {
    popup: {
      title: {
        id: "input_profile_id_popup_title",
        defaultMessage: "Recherche et sélectionne un profil",
      },
    },
    limitChoice: 1,
  },
  manager: {
    popup: {
      title: {
        id: "input_manager_popup_title",
        defaultMessage: "Recherche et sélectionne un responsable",
      },
    },
    limitChoice: 1,
  },

  objective_recipient: {
    popup: {
      title: {
        id: "input_objective_recipient_popup_title",
        defaultMessage: "Recherche et sélectionne un collaborateur",
      },
    },
    limitChoice: 1,
  },

  candidate: {
    popup: {
      title: {
        id: "input_candidate_popup_title",
        defaultMessage: "Recherche et sélectionne un candidat",
      },
    },
    limitChoice: 1,
  },

  subCompany: {
    popup: {
      title: {
        id: "input_subcompany_popup_title",
        defaultMessage: "Recherche et sélectionne une société sous-traitante",
      },
    },
    limitChoice: 1,
  },
  historyCompany: {
    popup: {
      title: {
        id: "input_company_history_popup_title",
        defaultMessage: "Rechercher et sélectionner une société de facturation",
      },
    },
    limitChoice: 1,
  },
  ADV: {
    popup: {
      title: {
        id: "input_ADV_popup_title",
        defaultMessage: "Recherche et sélectionne un ADV",
      },
    },
    limitChoice: 1,
  },
  CSLT_STR: {
    popup: {
      title: {
        id: "input_CSLT_STR_popup_title",
        defaultMessage: "Recherche et sélectionne un Consultant/Sous-traitant",
      },
    },
    limitChoice: 1,
  },
  personal_management: {
    popup: {
      title: {
        id: "input_personal_management_popup_title",
        defaultMessage: "Recherche et sélectionne un gestionnaire du personnel",
      },
    },
    limitChoice: 1,
  },
  start_date: {
    id: "input-date-start_date",
  },
  end_date: {
    id: "input-date-end_date",
  },

  syntec_coef_position_staff: {
    popup: {
      title: {
        id: "input_syntec_coefficient_id_popup_title",
        defaultMessage: "Recherche et sélectionne un coefficient/position",
      },
    },
    limitChoice: 1,
  },
  coefficient: {
    popup: {
      title: {
        id: "input_coefficient_popup_title",
        defaultMessage: "Recherche et sélectionne un coefficient",
      },
    },
    limitChoice: 1,
  },
  position: {
    popup: {
      title: {
        id: "input_position_popup_title",
        defaultMessage: "Recherche et sélectionne un coefficient/position",
      },
    },
    limitChoice: 1,
  },
  leaving_reason: {
    popup: {
      title: {
        id: "input_leaving_reason_popup_title",
        defaultMessage: "Recherche et sélectionne un motif de sortie",
      },
    },
    limitChoice: 1,
  },
  roles: {
    popup: {
      title: {
        id: "input_roles_popup_title",
        defaultMessage: "Recherche et sélectionne un rôle",
      },
    },
    limitChoice: 20,
  },
  assigned_branches: {
    popup: {
      title: {
        id: "input_branch_popup_title",
        defaultMessage: "Recherche et sélectionne une filiale",
      },
    },
    limitChoice: 1,
  },
  sector: {
    popup: {
      title: {
        id: "input_sector_popup_title",
        defaultMessage: "Recherche et sélectionne un secteur",
      },
    },
    limitChoice: 20,
  },
  statusFilter: {
    popup: {
      title: {
        id: "input_status_filter_popup_title",
        defaultMessage: "Rechercher et selectionner un statut",
      },
    },
    limitChoice: 1,
  },
  workerFilter: {
    popup: {
      title: {
        id: "input_worker_filter_popup_title",
        defaultMessage:
          "Rechercher et selectionner un consultant/sous-traitant",
      },
    },
    limitChoice: 1,
  },
  clientFilter: {
    popup: {
      title: {
        id: "input_client_filter_popup_title",
        defaultMessage: "Rechercher et selectionner un client",
      },
    },
  },
  managerFilter: {
    popup: {
      title: {
        id: "input_manager_filter_popup_title",
        defaultMessage: "Rechercher et selectionner un manager",
      },
    },
    limitChoice: 1,
  },
  branchFilter: {
    popup: {
      title: {
        id: "branch_filter_popup_title",
        defaultMessage: "Rechercher et selectionner une branche",
      },
    },
    limitChoice: 1,
  },
  affiliateFilter: {
    popup: {
      title: {
        id: "affiliate_filter_popup_title",
        defaultMessage: "Rechercher et selectionner un client",
      },
    },
    limitChoice: 1,
  },
  assignedManagers: {
    popup: {
      title: {
        id: "assigned_managers_filter_popup_title",
        defaultMessage: "Rechercher et selectionner un manager",
      },
    },
    limitChoice: 999,
  },
  purchasingContact: {
    popup: {
      title: {
        id: "purchasing_contact_filter_popup_title",
        defaultMessage: "Rechercher et selectionner un contact achats",
      },
    },
    limitChoice: 1,
  },
  eosUsers: {
    popup: {
      title: {
        id: "eos_users_filter_popup_title",
        defaultMessage: "Rechercher et selectionner un utilisateur EOS",
      },
    },
    limitChoice: 1,
  },
};

export const RULES = {
  email: /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/,
  positive_max_99: /^(\d){0,2}$/,
  positive_max_9999: /^(\d){0,4}$/,
  positive_max_9999_decimal: /^(\d){0,4}([.,]\d{0,2})?$/,
  positive_max_99999: /^(\d){0,5}$/,
  positive_max_99999_decimal: /^(\d){0,5}([.,]\d{0,2})?$/,
  year: /^(181[2-9]|18[2-9]\d|19\d\d|2\d{3}|30[0-3]\d|304[0-8])$/,
  phone_number: /^\+?\s?\d[\d\s.]{8,19}$/,
  pattern_siren: /^(\d{9})$/,
  positive_float_pattern: /^(\d+([.,]\d*)?|[.,]\d+)([eE][-+]?\d+)?$/,
  between30_60_char: /^.{30,60}$/,
  pattern_zip_code: /^[a-zA-Z0-9]{0,9}$/,
  daily_fee_pattern: /^\d+(\.\d{1,2})?$/,
  mission_description: /^(?=(\w+\s){50,})(?=(-\s.*\n){5,})/,
  fifty_words_min: /^(?=(\w+\s){50,})/,
  min_1_max_64_no_spaces: /^.{1,64}$/,
  min_2_max_64_no_spaces: /^.{2,64}$/,
  min_5_max_500_char: /^[\s\S]{5,500}$/,
  min_2_max_200_char: /^.{2,200}$/,
  create_path_pattern: /^\/(\w+)\/create$/,
  display_path_pattern: /^\/?(\w+)\/.+$/,
  amount_input: /^-?\d*[.,]?\d*$/,
  linkedin_url: /^https?:\/\/[^\s]*linkedin[^\s]*$/i,
  sharepoint_url: /^\s*https?:\/\/davidsoncorp\.sharepoint\.com\/\S*\s*$/i,
};

export const DELIVERY_NOTE_FORM_LABELS = {
  name: { id: "delivery_note_label_name", defaultMessage: "Nom du modèle" },
  title: { id: "delivery_note_label_title", defaultMessage: "Titre" },
  subtitle: { id: "delivery_note_label_subtitle", defaultMessage: "Sous-titre" },
  currency: { id: "input_currency_id_label", defaultMessage: "Devise" },
  pdf_file_name: {
    id: "delivery_note_label_pdf_file_name",
    defaultMessage: "Nom du fichier PDF",
  },
  company: { id: "delivery_note_label_company", defaultMessage: "Entreprise" },
  address: { id: "delivery_note_label_address", defaultMessage: "Adresse" },
  siret: { id: "input_siret_label", defaultMessage: "Siret" },
  phone: { id: "input_phone_number_label", defaultMessage: "Téléphone" },
  column_name: { id: "delivery_note_label_column_name", defaultMessage: "Nom" },
  column_a: {
    id: "delivery_note_label_column_a",
    defaultMessage: "Colonne A",
  },
  column_b: {
    id: "delivery_note_label_column_b",
    defaultMessage: "Colonne B",
  },
  issuer_signatory: {
    id: "delivery_note_label_issuer_signatory",
    defaultMessage: "Signataire n°1 (émetteur)",
  },
  recipient_signatory: {
    id: "delivery_note_label_recipient_signatory",
    defaultMessage: "Signataire n°2 (client)",
  },
};

export const DELIVERY_NOTE_PDF_NAME_LABELS = {
  automatic: {
    id: "delivery_note_pdf_name_automatic_option",
    defaultMessage: "Nom automatique",
  },
  custom: {
    id: "delivery_note_pdf_name_custom_option",
    defaultMessage: "Nom personnalisé",
  },
  automaticHint: {
    id: "delivery_note_pdf_name_automatic_hint",
    defaultMessage:
      "Chaque PDF est nommé à partir du numéro du bon. Exemple : {example}",
  },
  suffix: {
    id: "delivery_note_pdf_name_suffix",
    defaultMessage:
      "Ajouter le mois et l'année à la fin du nom (ex. _0926 pour septembre 2026)",
  },
  example: {
    id: "delivery_note_pdf_name_example",
    defaultMessage: "Nom du fichier : {example}",
  },
  field: {
    id: "delivery_note_pdf_name_field",
    defaultMessage: "Nom du fichier",
  },
};

export const DELIVERY_NOTE_FORM_PLACEHOLDERS = {
  name: {
    id: "delivery_note_placeholder_name",
    defaultMessage: "Ex : Davidson × SNCF",
  },
  title: {
    id: "delivery_note_placeholder_title",
    defaultMessage: "Procès verbal de recette",
  },
  subtitle: {
    id: "delivery_note_placeholder_subtitle",
    defaultMessage: "BON DE LIVRAISON",
  },
  pdf_file_name: {
    id: "delivery_note_placeholder_pdf_file_name",
    defaultMessage: "Ex : BL_Davidson_SNCF",
  },
  address: {
    id: "delivery_note_placeholder_address",
    defaultMessage: "Adresse",
  },
  siret: {
    id: "input_siret_placeholder",
    defaultMessage: "XXX XXX XXX XXXX",
  },
  phone: {
    id: "input_client_contact_phonenumber_placeholder",
    defaultMessage: "01.02.03.04.05",
  },
  column_name: {
    id: "delivery_note_placeholder_column_name",
    defaultMessage: "Nom de la colonne",
  },
  signatory: {
    id: "delivery_note_placeholder_signatory",
    defaultMessage: "Nom et prénom",
  },
};

export const DELIVERY_NOTE_COLUMN_BADGES = {
  simple: {
    id: "delivery_note_add_simple_column",
    defaultMessage: "Colonne simple",
  },
  linked: {
    id: "delivery_note_add_linked_column",
    defaultMessage: "Colonnes liées",
  },
};

export const DELIVERY_NOTE_TEMPLATE_ACTIONS = {
  preview: { id: "delivery_note_preview", defaultMessage: "Aperçu" },
  edit: {
    id: "delivery_note_templates_edit",
    defaultMessage: "Modifier le modèle",
  },
  addFavorite: {
    id: "delivery_note_templates_add_favorite",
    defaultMessage: "Ajouter aux favoris",
  },
  removeFavorite: {
    id: "delivery_note_templates_remove_favorite",
    defaultMessage: "Retirer des favoris",
  },
  delete: {
    id: "delivery_note_templates_delete",
    defaultMessage: "Supprimer le modèle",
  },
  makePublic: {
    id: "delivery_note_templates_make_public",
    defaultMessage: "Rendre visible par tous",
  },
  removePublic: {
    id: "delivery_note_templates_remove_public",
    defaultMessage: "Retirer la visibilité publique",
  },
};

export const DELIVERY_NOTE_MODULE_INTRO = {
  id: "delivery_note_module_intro",
  defaultMessage:
    "Le module fonctionne en deux temps. Vous créez d'abord un modèle : la trame réutilisable de vos bons de livraison — émetteur, client, colonnes, signataires. Vous générez ensuite un bon de livraison à partir de ce modèle, en y saisissant le n° de commande, la date de remise et les lignes. Un modèle ne contient aucune ligne et n'est pas un bon de livraison.",
};

export const DELIVERY_NOTE_MODULE_TIP = {
  id: "delivery_note_module_tip",
  defaultMessage:
    "<b>Astuce</b> : d'un mois sur l'autre, pas besoin de tout ressaisir — ouvrez un bon existant, ajustez les lignes et les dates, puis enregistrez-le comme un nouveau bon (le bon d'origine reste intact, un nouveau n° BL est attribué automatiquement).",
};

export const DELIVERY_NOTE_CREATE_HEADER = {
  title: {
    id: "delivery_note_create_title",
    defaultMessage: "Créer un modèle",
  },
  editTitle: {
    id: "delivery_note_edit_template_title",
    defaultMessage: "Modifier le modèle",
  },
  subtitle: {
    id: "delivery_note_create_subtitle",
    defaultMessage:
      "Définissez une trame réutilisable : identité du document, émetteur, client, colonnes et signataires. Aucune ligne n'est saisie à cette étape.",
  },
  notice: {
    id: "delivery_note_create_notice",
    defaultMessage:
      "Vous créez ici un modèle, c'est-à-dire la trame réutilisable de vos bons de livraison. Cette page ne produit pas de bon de livraison : une fois le modèle enregistré, ouvrez l'onglet « Générer un bon de livraison » pour saisir les lignes et éditer le document.",
  },
};

export const DELIVERY_NOTE_FILTERS = {
  name: DELIVERY_NOTE_FORM_LABELS.name,
  branches: {
    id: "delivery_note_templates_filter_branches",
    defaultMessage: "Filiales",
  },
  clients: { id: "clients", defaultMessage: "Clients" },
};

export const DELIVERY_NOTE_FILTERS_DEFAULTS = {
  name: "",
  branches: [],
  clients: [],
};

export const DELIVERY_NOTE_FILTER_LIMIT = 10;

export const DELIVERY_NOTE_TEMPLATE_MESSAGES = {
  title: {
    id: "delivery_note_templates_title",
    defaultMessage: "Mes modèles",
  },
  subtitle: {
    id: "delivery_note_templates_subtitle",
    defaultMessage:
      "Gérez vos modèles : aperçu, modification, partage avec vos collègues, mise en favori, suppression.",
  },
  empty: {
    id: "delivery_note_templates_empty",
    defaultMessage: "Aucun modèle pour le moment.",
  },
  noMatch: {
    id: "delivery_note_templates_no_match",
    defaultMessage: "Aucun modèle ne correspond à votre recherche.",
  },
  publicBadge: {
    id: "delivery_note_templates_public_badge",
    defaultMessage: "Visible par tous",
  },
};

export const DELIVERY_NOTE_TEMPLATE_DELETE = {
  validationMessages: {
    title: "delivery_note_templates_delete_title",
    message: "delivery_note_templates_delete_message",
  },
};

export const DELIVERY_NOTE_TEMPLATE_ITEM_DETAIL = {
  id: "delivery_note_templates_item_detail",
  defaultMessage:
    "{issuer} → {recipient} · {simple} simple(s), {linked} liée(s)",
};

export const DELIVERY_NOTE_RECEIVED_TEMPLATE_ACTIONS = {
  preview: {
    id: "delivery_note_received_templates_preview",
    defaultMessage: "Aperçu",
  },
  import: {
    id: "delivery_note_received_templates_import",
    defaultMessage: "Importer",
  },
  dismiss: {
    id: "delivery_note_received_templates_dismiss",
    defaultMessage: "Retirer de la liste",
  },
  importFromPreview: {
    id: "delivery_note_received_templates_import_from_preview",
    defaultMessage: "Importer dans mes modèles",
  },
  close: { id: "close", defaultMessage: "Fermer" },
};

export const DELIVERY_NOTE_RECEIVED_TEMPLATE_MESSAGES = {
  title: {
    id: "delivery_note_received_templates_title",
    defaultMessage: "Modèles partagés par d'autres utilisateurs",
  },
  subtitle: {
    id: "delivery_note_received_templates_subtitle",
    defaultMessage:
      "Ces modèles ont été rendus visibles par vos collègues. Vous pouvez les utiliser ou les copier dans votre bibliothèque.",
  },
  empty: {
    id: "delivery_note_received_templates_empty",
    defaultMessage: "Aucun modèle partagé pour l'instant",
  },
  loadError: {
    id: "delivery_note_received_templates_load_error",
    defaultMessage: "Les modèles partagés n'ont pas pu être chargés.",
  },
  sharedBy: {
    id: "delivery_note_received_templates_shared_by",
    defaultMessage: "Partagé par {name}",
  },
  unknownSender: {
    id: "delivery_note_received_templates_unknown_sender",
    defaultMessage: "un collègue",
  },
  noMatch: {
    id: "delivery_note_received_templates_no_match",
    defaultMessage: "Aucun modèle partagé ne correspond à votre recherche.",
  },
};

export const DELIVERY_NOTE_RECEIVED_TEMPLATE_DISMISS = {
  validationMessages: {
    title: "delivery_note_received_templates_dismiss_title",
    message: "delivery_note_received_templates_dismiss_message",
  },
  confirmLabel: {
    id: "delivery_note_received_templates_dismiss_confirm",
    defaultMessage: "Retirer",
  },
};

export const DELIVERY_NOTE_PUBLIC_TEMPLATE_ACTIONS = {
  preview: {
    id: "delivery_note_public_templates_preview",
    defaultMessage: "Aperçu",
  },
  import: {
    id: "delivery_note_public_templates_import",
    defaultMessage: "Importer",
  },
};

export const DELIVERY_NOTE_PUBLIC_TEMPLATE_MESSAGES = {
  title: {
    id: "delivery_note_public_templates_title",
    defaultMessage: "Modèles publics",
  },
  subtitle: {
    id: "delivery_note_public_templates_subtitle",
    defaultMessage:
      "Ces modèles ont été rendus visibles par tous. Vous pouvez les utiliser ou les copier dans votre bibliothèque.",
  },
  empty: {
    id: "delivery_note_public_templates_empty",
    defaultMessage: "Aucun modèle public pour l'instant",
  },
  loadError: {
    id: "delivery_note_public_templates_load_error",
    defaultMessage: "Les modèles publics n'ont pas pu être chargés.",
  },
  publishedBy: {
    id: "delivery_note_public_templates_published_by",
    defaultMessage: "Publié par {name}",
  },
  unknownPublisher: {
    id: "delivery_note_public_templates_unknown_publisher",
    defaultMessage: "un collègue",
  },
  noMatch: {
    id: "delivery_note_public_templates_no_match",
    defaultMessage: "Aucun modèle public ne correspond à votre recherche.",
  },
};

export const DELIVERY_NOTE_SHARE_ACTIONS = {
  share: {
    id: "delivery_note_share_action",
    defaultMessage: "Partager avec un collègue",
  },
  submit: { id: "delivery_note_share_submit", defaultMessage: "Partager" },
  cancel: { id: "cancel", defaultMessage: "Annuler" },
};

export const DELIVERY_NOTE_SHARE_MESSAGES = {
  title: {
    id: "delivery_note_share_title",
    defaultMessage: "Partager : {name}",
  },
  subtitle: {
    id: "delivery_note_share_subtitle",
    defaultMessage: "{issuer} → {recipient}",
  },
  colleaguesLabel: {
    id: "delivery_note_share_colleagues_label",
    defaultMessage: "Partager avec :",
  },
  colleaguesPlaceholder: {
    id: "delivery_note_share_colleagues_placeholder",
    defaultMessage: "Rechercher un collègue...",
  },
  colleaguesPopupTitle: {
    id: "delivery_note_share_colleagues_popup_title",
    defaultMessage: "Rechercher et sélectionner des collègues",
  },
  messageLabel: {
    id: "delivery_note_share_message_label",
    defaultMessage: "Message (optionnel) :",
  },
  messagePlaceholder: {
    id: "delivery_note_share_message_placeholder",
    defaultMessage: "Je te partage ce modèle de bon de livraison...",
  },
  alreadySharedWith: {
    id: "delivery_note_share_already_shared_with",
    defaultMessage: "Déjà partagé avec",
  },
  unknownColleague: {
    id: "delivery_note_share_unknown_colleague",
    defaultMessage: "un collègue",
  },
  hint: {
    id: "delivery_note_share_hint",
    defaultMessage: "Le modèle apparaîtra dans leur bibliothèque",
  },
  noColleagueSelected: {
    id: "delivery_note_share_no_colleague_selected",
    defaultMessage: "Sélectionnez au moins un collègue.",
  },
  pendingTitle: {
    id: "delivery_note_share_pending_title",
    defaultMessage: "Partage en cours...",
  },
  successTitle: {
    id: "delivery_note_share_success_title",
    defaultMessage: "Modèle partagé",
  },
  successMessage: {
    id: "delivery_note_share_success_message",
    defaultMessage: "« {name} » a été partagé avec {colleagues}.",
  },
  errorTitle: {
    id: "delivery_note_share_error_title",
    defaultMessage: "Le partage a échoué",
  },
  errorMessage: {
    id: "delivery_note_share_error_message",
    defaultMessage:
      "Le modèle n'a pas pu être partagé. Vos destinataires et votre message sont conservés, réessayez.",
  },
};

export const DELIVERY_NOTE_SUBMIT_LABELS = {
  create: { id: "delivery_note_submit", defaultMessage: "Valider la création" },
  update: { id: "delivery_note_update_submit", defaultMessage: "Sauvegarder" },
};

export const DELIVERY_NOTE_PREVIEW_NO_COLUMN = {
  id: "delivery_note_preview_no_column",
  defaultMessage: "Aucune colonne",
};

export const DELIVERY_NOTE_CONFIRM_MODAL_MESSAGES = {
  templateCreate: {
    successTitleId: "delivery_note_saved_title",
    successTitleDefault: "Modèle enregistré",
    successMessageId: "delivery_note_saved_message",
    successMessageDefault: "Votre modèle de bon de livraison a bien été créé.",
    errorMessageId: "delivery_note_template_save_error",
    errorMessageDefault: "Le modèle n'a pas pu être enregistré.",
  },
  templateUpdate: {
    successTitleId: "delivery_note_updated_title",
    successTitleDefault: "Modifications enregistrées",
    successMessageId: "delivery_note_updated_message",
    successMessageDefault:
      "Votre modèle de bon de livraison a bien été modifié.",
    errorMessageId: "delivery_note_template_save_error",
    errorMessageDefault: "Le modèle n'a pas pu être enregistré.",
  },
  templateDelete: {
    successTitleId: "delivery_note_templates_deleted_title",
    successTitleDefault: "Modèle supprimé",
    successMessageId: "delivery_note_templates_deleted",
    successMessageDefault: "Le modèle a bien été supprimé.",
    errorMessageId: "delivery_note_templates_delete_error",
    errorMessageDefault: "Ce modèle n'a pas pu être supprimé.",
  },
  templateImportReceived: {
    successTitleId: "delivery_note_templates_imported_title",
    successTitleDefault: "Modèle importé",
    successMessageId: "delivery_note_received_templates_imported",
    successMessageDefault: 'Le modèle "{name}" a été importé dans vos modèles.',
    errorMessageId: "delivery_note_received_templates_import_error",
    errorMessageDefault: "Ce modèle n'a pas pu être importé.",
  },
  templateImportPublic: {
    successTitleId: "delivery_note_templates_imported_title",
    successTitleDefault: "Modèle importé",
    successMessageId: "delivery_note_public_templates_imported",
    successMessageDefault: 'Le modèle "{name}" a été importé dans vos modèles.',
    errorMessageId: "delivery_note_public_templates_import_error",
    errorMessageDefault: "Ce modèle n'a pas pu être importé.",
  },
  templateDismiss: {
    successTitleId: "delivery_note_received_templates_dismissed_title",
    successTitleDefault: "Modèle retiré",
    successMessageId: "delivery_note_received_templates_dismissed",
    successMessageDefault:
      'Le modèle partagé "{name}" a été retiré de votre liste.',
    errorMessageId: "delivery_note_received_templates_dismiss_error",
    errorMessageDefault: "Ce modèle n'a pas pu être retiré.",
  },
  noteCreate: {
    successTitleId: "delivery_note_generate_saved_title",
    successTitleDefault: "Bon enregistré",
    successMessageId: "delivery_note_generate_saved_message",
    successMessageDefault:
      'Votre bon de livraison a bien été enregistré dans "Bons enregistrés".',
    errorMessageId: "delivery_note_save_error",
    errorMessageDefault: "Le bon n'a pas pu être enregistré.",
  },
  noteUpdate: {
    successTitleId: "delivery_note_generate_updated_title",
    successTitleDefault: "Bon mis à jour",
    successMessageId: "delivery_note_generate_updated_message",
    successMessageDefault: "Votre bon de livraison a bien été mis à jour.",
    errorMessageId: "delivery_note_update_error",
    errorMessageDefault: "Le bon n'a pas pu être mis à jour.",
  },
  noteDuplicate: {
    successTitleId: "delivery_note_generate_duplicated_title",
    successTitleDefault: "Bon dupliqué",
    successMessageId: "delivery_note_generate_duplicated_message",
    successMessageDefault:
      'Une copie du bon a été enregistrée dans "Bons enregistrés".',
    errorMessageId: "delivery_note_save_error",
    errorMessageDefault: "Le bon n'a pas pu être enregistré.",
  },
  noteDelete: {
    successTitleId: "delivery_note_saved_notes_deleted_title",
    successTitleDefault: "Bon supprimé",
    successMessageId: "delivery_note_saved_notes_deleted",
    successMessageDefault: "Le bon a bien été supprimé.",
    errorMessageId: "delivery_note_saved_notes_delete_error",
    errorMessageDefault: "Ce bon n'a pas pu être supprimé.",
  },
};

export const DELIVERY_NOTE_DEFAULT_COLUMN_NAMES = {
  simple: {
    id: "delivery_note_default_simple_column",
    defaultMessage: "Nouvelle colonne",
  },
  quantity: {
    id: "delivery_note_default_quantity_column",
    defaultMessage: "Quantité",
  },
  unit_price: {
    id: "delivery_note_default_unit_price_column",
    defaultMessage: "Prix unitaire en {currency} HT",
  },
  total: {
    id: "delivery_note_total_column",
    defaultMessage: "Montant total",
  },
};

export const DELIVERY_NOTE_DEFAULT_SIGNATORIES = {
  issuer: {
    id: "delivery_note_default_issuer_signatory",
    defaultMessage: "Signataire n°1",
  },
  recipient: {
    id: "delivery_note_default_recipient_signatory",
    defaultMessage: "Signataire n°2",
  },
};

export const DELIVERY_NOTE_IMAGE_FIELDS = [
  "issuer_logo_file_id",
  "recipient_logo_file_id",
  "issuer_signature_file_id",
  "recipient_signature_file_id",
];

export const DELIVERY_NOTE_FORM_DEFAULT_VALUES = {
  name: "",
  title: "",
  subtitle: "",
  currency_id: "",
  pdf_file_name: "",
  pdf_file_name_mode: DELIVERY_NOTE_PDF_NAME_MODES.AUTOMATIC,
  pdf_suffix_enabled: true,
  issuer_logo_file_id: null,
  issuer_company: [],
  issuer_address: "",
  issuer_siret: "",
  issuer_phone: "",
  recipient_logo_file_id: null,
  recipient_company: [],
  recipient_address: "",
  recipient_siret: "",
  recipient_phone: "",
  columns: [],
  issuer_signature_file_id: null,
  issuer_signatory_name: "",
  recipient_signature_file_id: null,
  recipient_signatory_name: "",
};

export const DELIVERY_NOTE_PARTIES_DETAIL = {
  id: "delivery_note_parties_detail",
  defaultMessage: "{issuer} → {recipient}",
};

export const DELIVERY_NOTE_GENERATE_LABELS = {
  title: {
    id: "delivery_note_generate_title",
    defaultMessage: "Générer un bon de livraison",
  },
  subtitle: {
    id: "delivery_note_generate_subtitle",
    defaultMessage:
      "Choisissez un modèle, complétez les informations du bon, saisissez les lignes, puis enregistrez le bon ou téléchargez-le en PDF.",
  },
  chooseTemplate: {
    id: "delivery_note_generate_choose_template",
    defaultMessage: "Choisir un modèle",
  },
  infoBlock: {
    id: "delivery_note_generate_info_block",
    defaultMessage: "Informations du bon",
  },
  linesBlock: {
    id: "delivery_note_generate_lines_block",
    defaultMessage: "Lignes",
  },
  orderNumber: {
    id: "delivery_note_generate_order_number",
    defaultMessage: "N° commande",
  },
  number: {
    id: "delivery_note_generate_number",
    defaultMessage: "N° BL (identifiant du bon)",
  },
  deliveryDate: {
    id: "delivery_note_generate_delivery_date",
    defaultMessage: "Date de remise",
  },
  addLine: {
    id: "delivery_note_generate_add_line",
    defaultMessage: "+ Ajouter une ligne",
  },
  removeLine: {
    id: "delivery_note_generate_remove_line",
    defaultMessage: "Supprimer la ligne",
  },
  selected: {
    id: "delivery_note_generate_selected",
    defaultMessage: "Sélectionné",
  },
  emptyPreview: {
    id: "delivery_note_generate_empty_preview",
    defaultMessage: "Sélectionnez un modèle pour afficher l'aperçu",
  },
  noTemplate: {
    id: "delivery_note_generate_no_template",
    defaultMessage:
      "Créez d'abord un modèle pour pouvoir générer un bon de livraison.",
  },
  editedTemplate: {
    id: "delivery_note_generate_edited_template",
    defaultMessage: "Modèle : {name}",
  },
  editNotice: {
    id: "delivery_note_generate_edit_notice",
    defaultMessage:
      "Vous éditez le bon {number}. Modifiez les informations puis mettez à jour, ou enregistrez-le comme nouveau bon (un nouveau N° BL sera automatiquement attribué)",
  },
};

export const DELIVERY_NOTE_PAGE_ATTRIBUTE = "data-delivery-note-page";
export const DELIVERY_NOTE_PAGE_SELECTOR = `[${DELIVERY_NOTE_PAGE_ATTRIBUTE}]`;

export const DELIVERY_NOTE_TOTAL_HT = {
  id: "delivery_note_preview_total_ht",
  defaultMessage: "Total HT : {total}",
};

export const DELIVERY_NOTE_GENERATE_ACTIONS = {
  cancel: { id: "cancel", defaultMessage: "Annuler" },
  save: {
    id: "delivery_note_generate_save",
    defaultMessage: "Enregistrer le bon",
  },
  saveAsNew: {
    id: "delivery_note_generate_save_as_new",
    defaultMessage: "Enregistrer comme nouveau bon",
  },
  update: {
    id: "delivery_note_generate_update",
    defaultMessage: "Mettre à jour ce bon",
  },
  pdf: { id: "delivery_note_generate_pdf", defaultMessage: "PDF" },
};

export const DELIVERY_NOTE_SAVED_LIST_ACTIONS = {
  preview: {
    id: "delivery_note_saved_notes_preview",
    defaultMessage: "Aperçu du bon",
  },
  edit: {
    id: "delivery_note_saved_notes_edit",
    defaultMessage: "Modifier le bon",
  },
  pdf: {
    id: "delivery_note_saved_notes_pdf",
    defaultMessage: "Télécharger le bon en PDF",
  },
  delete: {
    id: "delivery_note_saved_notes_delete",
    defaultMessage: "Supprimer le bon",
  },
  close: { id: "close", defaultMessage: "Fermer" },
  previewDownload: {
    id: "delivery_note_saved_notes_preview_download",
    defaultMessage: "Télécharger PDF",
  },
};

export const DELIVERY_NOTE_SAVED_DELETE = {
  validationMessages: {
    title: "delivery_note_saved_notes_delete_title",
    message: "delivery_note_saved_notes_delete_message",
  },
};

export const DELIVERY_NOTE_SAVED_LIST_MESSAGES = {
  search: {
    id: "delivery_note_saved_notes_search",
    defaultMessage: "N° de commande ou nom du modèle",
  },
  title: {
    id: "delivery_note_saved_notes_title",
    defaultMessage: "Bons enregistrés",
  },
  subtitle: {
    id: "delivery_note_saved_notes_subtitle",
    defaultMessage:
      "Retrouvez, prévisualisez, modifiez et exportez en PDF tous les bons de livraison que vous avez déjà enregistrés.",
  },
  empty: {
    id: "delivery_note_saved_notes_empty",
    defaultMessage: "Vous n'avez encore enregistré aucun bon de livraison.",
  },
  noMatch: {
    id: "delivery_note_saved_notes_no_match",
    defaultMessage: "Aucun bon ne correspond à votre recherche.",
  },
  loadError: {
    id: "delivery_notes_load_error",
    defaultMessage: "Les bons n'ont pas pu être chargés.",
  },
  columnNumber: {
    id: "delivery_note_saved_notes_column_number",
    defaultMessage: "N° BL",
  },
  columnOrderNumber: {
    id: "delivery_note_saved_notes_column_order_number",
    defaultMessage: "N° commande",
  },
  columnTemplate: {
    id: "delivery_note_saved_notes_column_template",
    defaultMessage: "Modèle",
  },
  columnParties: {
    id: "delivery_note_saved_notes_column_parties",
    defaultMessage: "Parties",
  },
  columnDeliveryDate: {
    id: "delivery_note_saved_notes_column_delivery_date",
    defaultMessage: "Date de remise",
  },
  columnTotal: {
    id: "delivery_note_saved_notes_column_total",
    defaultMessage: "Total HT",
  },
  columnActions: {
    id: "delivery_note_saved_notes_column_actions",
    defaultMessage: "Actions",
  },
};
